import { QUICK_FILTERS_KEY } from "modules/common/constants/QuickFilters";

export const FILTERS_KEYS = {
  QUICK_FILTERS: QUICK_FILTERS_KEY,
  CUSTOMER_ID: "customerId",
  PERMISSIONS: "permissions",
  PERMISSIONS_CONDITION: "permissionsCondition",
  USER_TYPE: "type",
} as const;

export const PERMISSIONS_CONDITIONS = {
  ANY: "any",
  ALL: "all",
  NONE: "none",
} as const;

export const QUICK_FILTERS = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
} as const;

export const QUICK_FILTERS_VALUES = Object.values(QUICK_FILTERS);

export const DEFAULT_FILTERS = {
  quickFilters: [],
  customerId: [],
  permissions: [],
  permissionsCondition: PERMISSIONS_CONDITIONS.ANY,
  type: [],
};

export const DEFAULT_FILTERS_CONFIGURATION = {
  quickFilters: {
    array: true,
    defaultValue: [],
  },
  customerId: {
    array: true,
    defaultValue: [],
  },
  permissions: {
    array: true,
    defaultValue: [],
  },
  permissionsCondition: {
    defaultValue: PERMISSIONS_CONDITIONS.ANY,
  },
  type: {
    array: true,
    defaultValue: [],
  },
};
